<template>
  <div class="content">
    <div class="banner">
        <img :src="$t('about.banner')">
    </div>
    <!-- 内容的富文本 -->
    <div v-html="$t('about.produce')" class="htmlbox"></div>

    <div class="core">
      <img :src="$t('about.coreBusiness')" alt="">
    </div>
  </div>
</template>

<script>
  import aboutApi from '../../api/about'
  import izh from "../../i18n/zh";
  import ien from "../../i18n/en";
  export default {
    name: 'about',

    data: () => ({
      //轮播图的循环时长
      carouselType:6000,
      //轮播图的数据
      changeIndex:0
    }),
    computed:{
      lang(){
        return this.$i18n.locale;
      }
    },
    methods:{
      async getData(){
        //获取banner和介绍
        let { data: bannerData } = await aboutApi.getBanner();
        //设置中英文数据
        izh.about = {
          ...izh.about,
          banner: bannerData.picturesZhCn,
          produce: bannerData.contentZhCn.replace(/style="">/gi,'style="width:100%;height:auto">'),
        };
        ien.about = {
          ...ien.about,
          banner: bannerData.picturesEnUs ? bannerData.picturesEnUs : bannerData.picturesZhCn,
          produce: bannerData.contentEnUs ? bannerData.contentEnUs.replace(/style=""/gi,'style="width:100%;height:auto">') : bannerData.contentZhCn.replace(/style="">/gi,'<img style="width:80%;height:auto" ')
        }
      }
    },
    async created(){
      //获取数据
      await this.getData();
    },
    mounted(){
      if( this.$refs.bannerVid ){
        this.bannerVideo = this.$refs.bannerVid[0];
        this.bannerVideo.addEventListener("play", () => {
          this.carouselType = 1000000000;
        });
        this.bannerVideo.addEventListener("pause", () => {
          this.carouselType = 6000;
        });
      }
      
    }
  }
</script>
<style lang="scss" scoped>
.content{
  margin-bottom: 180px;
}
.banner{
    width: 100%;
    margin-bottom: 20px;
    img{
      width: 100%;
    }
}
.htmlbox{
  width: 80%;
  overflow: hidden;
  margin-left: 10%;
}
.main-box{
  width: 80%;
  margin-left: 10%;
  .main-header{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 20px;
    span{
      width: 30px;
      height: 3px;
      border-radius: 3px;
      background: red;
    }
  }
}
.ip-box{
  width: 100%;
  margin-left: 0;
}
.ip-detail{
  margin-top: 20px;
  background: url('../../assets/images/about/bg.jpg');
  width: 100%;
  padding-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .ip-carousel{
    width: 300px;
    position: relative;
    video{
      height: 200px;
      width: 300px;
      object-fit: scale-down;
    }
    img{
      position: absolute;
      top: -20px;
      width: 20px;
      height: 20px;
    }
    .left_border{
      left: -20px
    }
    .right_border{
      right: -20px
    }
  }
  .ip-change{
    display: flex;
    width: 70%;
    max-width: 100%;
    margin-top: 20px;
    flex-wrap: wrap;
    justify-content: space-around;
    img{
      height: 10.8rem;
      width: 18rem;
      min-width: 100px;
      min-height: 60px;
    }
  }
  .ip-change-mobile{
    width: 100rem;
  }
}
.core{
  width: 100%;
  img{
    width: 100%;
  }
}
</style>
